import SendStatusView from './SendStatusView'
export default SendStatusView
